// extracted by mini-css-extract-plugin
export default {"body":"LayoutSga_body__XAcfO","container":"LayoutSga_container__BMQNV","bodyfake":"LayoutSga_bodyfake__572mz","miniContainer":"LayoutSga_miniContainer__0WPqQ"};